// The app's colours, defined once. The MUI palette reads them from here, and the theme's
// CssBaseline publishes them as CSS variables (var(--accent), var(--line) ...) for sx props
// and the .css files.
export const tokens = {
  // Dark enough for white text on it and for green text on white, bg and accentTint (WCAG AA, 4.5:1).
  accent: "#1b7d38",
  accentDark: "#156b30",
  accentTint: "#e9f6ec",
  ink: "#1f2420",
  muted: "#6b7470",
  mutedStrong: "#4a524d",
  line: "#e4e6e2",
  lineSoft: "#eeefeb",
  bg: "#fafaf8",
  card: "#ffffff",
  danger: "#dc2626",
  // Red text on a dangerTint background, where plain danger is too light to read.
  dangerDark: "#b91c1c",
  dangerTint: "#fef2f2",
  heart: "#e11d48",
};

// accentDark -> --accent-dark
export const cssVariables = Object.fromEntries(
  Object.entries(tokens).map(([name, value]) => [`--${name.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)}`, value])
);
